module.exports = __webpack_public_path__ + "static/media/standard-photo-product.9ecfc0b8.jpg";